export default {
  refreshCache: '刷新缓存',
  confirm: '确定',
  cancel: '取消',
  success: '成功',
  error: '失败',
  del: '删除',
  search: '搜索',
  detail: '详情',
  editor: '编辑',
  empty: '清空',
  emptyValue: '空值',
  add: '新增',
  export: '导出',
  login: '登录',
  hint: '提示',
  withdraw: '提现',
  review: '审核',
  pass: '通过',
  reject: '拒绝',
  test: '测试',
  next: '下一步',
  start: '启用',
  start1: '启用自动刷新',
  stop: '停用',
  stop1: '停用自动刷新',
  submit: '提交',
  recharge: '充值',
  transfer: '钱包转账',

  transferAmount: '额度转移',

  manual: '补单',
  callback: '回调',
  allOlder: '批量补单',
  qrCode: '二维码',
  取消出款: '取消出款',
  出款成功: '出款成功'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh/btns.js